<div class="main" (mouseover)="active=true" (mouseout)="active=false">
  <div class="header-container">
    <!-- <div class="header-con">
          <h4 class="header">{{heading}}</h4>
      </div>
 -->
    <div class="tools">
      <input type="search" placeholder="Search {{heading}}" (keyup)="searchQuery($event)" class="center-placeholder">

      <span [hidden]="showStep" uk-tooltip="Add New" *ngIf="addAvailable" class="add-icon float-right" uk-icon="plus"
        (click)="addModel('Add ')"></span>
    </div>

  </div>

  <ze-object-list-linear [listInteface]="list" [showStep]="showStep" [filter]="filter" [active]="active"
    [listfor]="heading" (onDelete)="delete($event)" (onEdit)="edit($event)" (onSaveAs)="saveAs($event)"></ze-object-list-linear>
</div>

<div class="uk-modal" id="add_element_model">
  <div class="uk-modal-dialog">
    <form class="uk-form-stacked">
      <div class="uk-modal-body">
        <label>{{modelLabel}}</label>
        <input class="uk-input" autofocus="">
      </div>
      <div class="uk-modal-footer uk-text-right">
        <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
        <button class="uk-button uk-button-primary">Ok</button>
      </div>
    </form>
  </div>
</div>